import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"];
import { useMemo } from 'react';
import { useGetAiAgentsForPortalQuery } from '../../../__generated__/chirp/com/hubspot/cv/ai/agents/configuration/rpc/AiAgentService.hooks';
export const useHasConfiguredCustomerAgent = () => {
  const _useGetAiAgentsForPor = useGetAiAgentsForPortalQuery(),
    {
      data
    } = _useGetAiAgentsForPor,
    rest = _objectWithoutPropertiesLoose(_useGetAiAgentsForPor, _excluded);
  const hasConfiguredAgent = useMemo(() => {
    return data ? data.results.length > 0 : undefined;
  }, [data]);
  return Object.assign({
    hasConfiguredAgent
  }, rest);
};